<template>
  <div>
    <b-modal
      :model-value="showDialogEdit"
      hide-footer
      hide-header-close
      centered
      :title="labels.information"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog edit-rol-dialog"
    >
      <div class="uniform-modal-body">
        <div class="password-policy-box mb-4">
          <div class="password-policy-title">{{ labels.infoTitle }}</div>
          <div class="password-policy-subtitle">{{ labels.infoText }}</div>
        </div>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.name }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-input 
              v-model="form.nombre" 
              type="text" 
              class="form-input" 
              autocomplete="off"
              placeholder="Nombre del rol"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.description }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-textarea 
              v-model="form.descripcion" 
              rows="3" 
              max-rows="6" 
              class="form-input"
              placeholder="Descripción del rol"
            ></b-form-textarea>
          </b-col>
        </b-row>

        <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
          <b-button class="mr-2 reset-btn-secondary" @click="closeModal()">{{ labels.cerrar }}</b-button>
          <b-button class="reset-btn-primary" @click="editInfoRol(form)">{{ labels.guardar }}</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Rol from "@/services/Roles";
export default {
    props: ['showDialogEdit', 'Item'],
    data() {
        return {
            isLoading: false,
            form: {
                id: null,
                nombre: '',
                descripcion: ''
            },
        }
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    information: "Editar Rol",
                    name: "Nombre",
                    description: "Descripción",
                    guardar: "Guardar",
                    cerrar: "Cerrar",
                    infoTitle: "Datos del rol",
                    infoText: "Actualiza la información y guarda los cambios."
                }
            } else {
                return {
                    information: "Edit Role",
                    name: "Name",
                    description: "Description",
                    guardar: "Save",
                    cerrar: "Close",
                    infoTitle: "Role information",
                    infoText: "Update the information and save changes."
                }
            }
        }
    },
    watch: {
        Item: {
            immediate: true,
            handler(newValue) {
                const currentItem = newValue || {};
                this.form = {
                    id: currentItem.id || null,
                    nombre: currentItem.nombre || '',
                    descripcion: currentItem.descripcion || ''
                };
            }
        }
    },
    methods: {
        editInfoRol(Item) {
            if (!Item.nombre) {
                this.$toast.error("Diligenciar el nombre del rol")
                return
            }
            if (!Item.descripcion) {
                this.$toast.error("Diligenciar la descripción del rol")
                return
            }

            this.isLoading = true;
            Item.idUser = this.$store.state.userId;
            
            Rol.updateRolById(Item)
                .then(() => {
                    this.$toast.success("Rol editado correctamente")
                    this.$emit('updated', {
                        id: Item.id,
                        nombre: Item.nombre,
                        descripcion: Item.descripcion
                    })
                    this.closeModal()
                })
                .catch((error) => {
                    console.log(error);
                    this.error = true;
                    this.$toast.error("No se pudo editar el rol")
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        closeModal() {
            this.$emit('closeModal', false)
        }
    }
}
</script>